(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
		
		
	});
	
})(jQuery);
 $(document).ready(function () {
    initHeaderSticky()
  });
  $(window).resize(function() {
    initHeaderSticky()
  });
  $(window).scroll(function() {
    initHeaderSticky()
  });
  function initHeaderSticky() {
    if (jQuery(document).height() > jQuery(window).height()) {
        if (jQuery('.header-layout-one .main-navigationbar').hasClass("sticky_header")) {
          if (jQuery(this).scrollTop() > 400) {
            jQuery('.header-layout-one .main-navigationbar').addClass("fixed");
          } else {
            jQuery('.header-layout-one .main-navigationbar').removeClass("fixed");
          }
        } else {
          jQuery('.header-layout-one .main-navigationbar').removeClass("fixed");
        }
    }
  }
$(document).ready(function(){

    // address page
    $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();
  
  jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<section class="cart-page-sec pt pb"><div class="container"><div class="order-historycontent"></div></div></section>');
  jQuery('.main-category-sec,.top-occassion-sec').wrapAll('<div class="bg-dark"></div>');
  jQuery('.cart-page-section .section-title.main').prependTo('.cart-page-section > .container');
  jQuery('main').insertAfter('header');
  countDownIni('.flip-countdown,.js-flip-countdown');
    /********* On scroll heder Sticky *********/
 var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      document.getElementById("header-sticky").style.top = "0";
    } else {
      document.getElementById("header-sticky").style.top = "-200px";
    }
    prevScrollpos = currentScrollPos;
  }
 /********* Mobile Menu ********/  
  $('.mobile-menu-button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
        $('body').addClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").toggleClass("active-menu");
        $('.overlay').addClass('menu-overlay');
    }, 50);
  }); 
  $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
      e.preventDefault(); 
      $('body').removeClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").removeClass("active-menu");
      $('.overlay').removeClass('menu-overlay');
  });
  /********* layout js *********/
    $('.demo-btn').on('click', function (e) {
      $('body').addClass('no-scroll');
      $('.layout-section').addClass('open');
    });
    $('.demo-close').on('click', function (e) {
      e.preventDefault();
      $('body').removeClass('no-scroll');
      $('.layout-section').removeClass('open');
    });
/********* mobile stickybar ********/
   $(window).scroll(function() {
     if ($(window).scrollTop() > 300) {
       $(".mobile-stickybar").addClass('show');
     } else {
       $(".mobile-stickybar").removeClass('show');
     }
   });
   /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });    
    var $this = $('.collection');
    if ($this.hasClass("collection-leftfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("collection-rightfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
       // ============= cart popup============
 if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
      $('body').addClass('no-scroll cartOpen');
      $('.disclosure__list-wrapper').addClass('hide');
  });
    
  }

  $('body').on('click', '.overlay.cart-overlay, .mini-cart-header, .closecart', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

    /*********coupon popup ********/
      $(document).on('click', '.coupan-icon', function () {
        $(".coupon-popup").toggleClass("active");
      });
      $(document).on('click', '.gift-icon', function () {
        $(".coupon-popup").removeClass("active");
      });
      $(document).on('click', '.close-coupon', function () {
        $(".coupon-popup").removeClass("active");
      });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });
  
/*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").addClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });

  
      /*********  ask qustion Popup  ********/
      $(".pro-features li a.ask-qus").click(function () {
        $(".ask-qus-popup").toggleClass("active");
        $("body").toggleClass("no-scroll");
      });
      $(".close-search").click(function () {
        $(".ask-qus-popup").removeClass("active");
        $("body").removeClass("no-scroll");
      });
     /*********  Multi-level accordion nav  ********/ 
     $('.acnav-label').click(function () {
         var label = $(this);
         var parent = label.parent('.has-children');
         var list = label.siblings('.acnav-list');
         if (parent.hasClass('is-open')) {
             list.slideUp('fast');
             parent.removeClass('is-open');
         }
         else {
             list.slideDown('fast');
             parent.addClass('is-open');
         }
     });

        /*********  Header Search Popup  ********/
        $(".search-header a").click(function () {
            $(".search-popup").toggleClass("active");
            $("body").toggleClass("no-scroll");
          });
          $(".close-search").click(function () {
            $(".search-popup").removeClass("active");
            $("body").removeClass("no-scroll");
          });

/********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").removeClass("product-grid-view");
      $(".grid-product .row").addClass("product-list-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);

        var prod_lable = jQuery(this).find('.product-top-content');
        jQuery(this).find('.prod-label').prependTo(prod_lable);

        var stock_label = jQuery(this).find('.prod-label');
        jQuery(this).find('.stock-label').insertAfter(stock_label);

        var prod_des = jQuery(this).find('h3');
        jQuery(this).find('.product-des').insertAfter(prod_des);

        var coll_count = jQuery(this).find('.product-des');
        jQuery(this).find('.collection-counter').insertAfter(coll_count);

        var prod_bottom = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_bottom);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);

        var prod_price = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_price);

        var prod_var = jQuery(this).find('.price');
        jQuery(this).find('.size-select').insertAfter(prod_var);

         var prod_btn = jQuery(this).find('.size-select');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_btn);
        
      });
    });

    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
                
        var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.prod-label').appendTo(prod_lable);

        var stock_label = jQuery(this).find('.prod-label');
        jQuery(this).find('.stock-label').insertAfter(stock_label);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.wish-lbl-wrp').appendTo(prod_btn);

        var prod_rev = jQuery(this).find('h3');
        jQuery(this).find('.rating-wrp').insertBefore(prod_rev);

        var coll_count = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.collection-counter').insertAfter(coll_count);
        
        var prod_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-card-content').insertAfter(prod_con);

        var prod_top = jQuery(this).find('.product-card-content');
        jQuery(this).find('.product-content-top').prependTo(prod_top);

        var prod_bottom = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_bottom);
        
      });
    });
  
       /****  TAB Js ****/
       $("ul.tabs li").click(function () {
        var $this = $(this);
        var $theTab = $(this).attr("data-tab");
        if ($this.hasClass("active")) {
        } else {
          $this
            .closest(".tabs-wrapper")
            .find("ul.tabs li, .tabs-container .tab-content")
            .removeClass("active");
          $(
            '.tabs-container .tab-content[id="' +
              $theTab +
              '"], ul.tabs li[data-tab="' +
              $theTab +
              "]"
          ).addClass("active");
        }
        $(this).addClass("active");
        });
 
      
           /******* Subscribe popup Js *******/
    if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no-scroll');
    });   
 
      /** footer acnav **/
      $('.acnav-label1').click(function (event) {
        event.preventDefault();
        if(jQuery( window ).width() < 768) {
          var label = $(this);
          var parent = label.parent('.has-children1');
          var list = label.siblings('.acnav-list1');
        if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
        }
        else {
          list.slideDown('fast');
          parent.addClass('is-open');
        }
      }
    });
  
    /** counter js **/
    $('.counting').each(function() {
      var $this = $(this),
          countTo = $this.attr('data-count');
      
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },
  
      {
        duration: 3000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }
  
      });  
    });
  /*** home banner slider **/
   var swiper = new Swiper(".home-banner-slider", {
    speed: 800,
    slidesPerView: 1,
    loop:true,
    navigation: {
        nextEl: ".home-banner-next-btn.swiper-button-next",
        prevEl: ".home-banner-prev-btn.swiper-button-prev",
      },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
    });
  /*** home banner slider **/
   var swiper = new Swiper(".main-right-slider", {
    loop:true,
    autoplay:true,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
    
    });

    /*** categories slider **/
   var swiper = new Swiper(".categories-slider", {
    slidesPerView: 6,
    spaceBetween: 15,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".product-next-btn.swiper-button-next",
      prevEl: ".product-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 6,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 2,
      },
    },
    });

    /** deal collection slider **/
    var swiper = new Swiper(".pro-feature-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      speed: 800,
      navigation: {
        nextEl: ".pro-feature-arrow.swiper-button-next",
        prevEl: ".pro-feature-arrow.swiper-button-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });

    /** /** best-seller-slider **/
    var swiper = new Swiper(".best-seller-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      speed: 800,
      autoplay:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 1,
        },
      },
    }); 

      var swiper = null;
    var isSwiperInitialized = false;
    function initSwiper() {

        //  two grid slider 
     swiper = new Swiper(".gallery-main", {
      slidesPerView: 1,
      spaceBetween: 10,
      freeMode: false,
      simulateTouch: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 0,
          freeMode: false,
          simulateTouch: false,
           slidesPerView: 1,
        },
          420: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    });
    }

    function destroySwiper() {
        if (swiper !== null) {
            swiper.destroy();
            swiper = null;
        }
    }

    function handleSwiper() {
        if (jQuery(window).width() < 768) {
            if (!isSwiperInitialized) {
                initSwiper();
                isSwiperInitialized = true;
            }
        } else {
            if (isSwiperInitialized) {
                destroySwiper();
                isSwiperInitialized = false;
            }
        }
    }
    
    // Function to handle resizing
    function handleResize() {
        $(window).resize(function () {
            if ($('.swiper').hasClass('gallery-main')) {
                handleSwiper();
            }
        }).trigger('resize');   
    }
    // Call handleResize function on page load
    $(document).ready(function () {
        handleResize();
    });

     /** new slider **/
     var swiper = new Swiper(".full-product-slider", {
      slidesPerView: 5,
      spaceBetween: 15,
      loop: true,
      speed: 800,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
        return `<span class="outer-dot swiper-pagination-bullet"><span class="inner-dot"></span></span>`;
        },
      },
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });

     /**testimonials slider **/
     var swiper = new Swiper(".testimonials-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      speed: 800,
      autoplay:true,
      navigation: {
        nextEl: ".testimonials-next.swiper-button-next",
        prevEl: ".testimonials-prev.swiper-button-prev",
      },
    });

    // ***blog-slider***/
   var swiper = new Swiper(".blog-slider", {
    spaceBetween: 30,
    slidesPerView: 3,
    loop: true,
    speed: 800,  
    centeredSlides:true,
    autoplay:false,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: true,
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
      return `<span class="outer-dot swiper-pagination-bullet"><span class="inner-dot"></span></span>`;
      },
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
       
      },
      768: {
        slidesPerView: 3,
        centeredSlides:false,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 2,
        centeredSlides:false,
        spaceBetween: 20,
      },
      320: {
        slidesPerView: 1,
        centeredSlides:false,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1,
        centeredSlides:false,
        spaceBetween: 20,
      },
    },
  });

       /** blog page slider **/
     var swiper = new Swiper(".elegant-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 800,
      autoplay:true,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
   /** client logo slider **/
   var swiper = new Swiper(".partner-logo-slider", {
    spaceBetween: 15,
    slidesPerView: 6,
    loop: true,
    speed: 800,
    // autoplay:true,
    navigation: {
      nextEl: ".partner-logo-next.swiper-button-next",
      prevEl: ".partner-logo-prev.swiper-button-prev",
    },
    breakpoints: {
      1200: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      576: {
        slidesPerView: 3,
      },
      476: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
 /*********  size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no-scroll");
   });
   $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
   });
   $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
   });
   /** our service slider **/
   var swiper = new Swiper(".service-slider", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".service-slider-arrow.swiper-button-next",
      prevEl: ".service-slider-arrow.swiper-button-prev",
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

   /** our team  slider **/
   var swiper = new Swiper(".our-team-slider", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    speed: 800,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
      return `<span class="outer-dot swiper-pagination-bullet"><span class="inner-dot"></span></span>`;
      },
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
         // currency-nice-select
$('body').on('click', '.country-name .nice-select', function (e) {
  e.stopPropagation(); // Stop the event from propagating to the body
  $(this).toggleClass('open');
});
$('body').on('click', function (e) {
  $('.country-name .nice-select').removeClass('open');
});

// currency
function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
  currencyItem.addEventListener('click', function () {
    // Trigger change event on the associated select element
    var selectElement = this.closest('.country-name').querySelector('select');
    if (selectElement) {
      // Set the selected option based on the data-currency attribute of the clicked li
      selectElement.value = this.dataset.currency;
      
      // Trigger change event
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);

      // Submit the form
      currencyFormSubmit({ target: selectElement });
    }
  });
});
  
/******* quick-view-popup Js *******/

   $('body').on('click', '.quick-close-btn', function(e) {
    e.preventDefault();
     $(".quick-view-popup").removeClass("active");
     $("body").removeClass("no-scroll");
  });

  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
       var swiper = new Swiper(".quickview-img-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: ".quickview-next-btn.swiper-button-next",
          prevEl: ".quickview-prev-btn.swiper-button-prev",
        },
        breakpoints: {
          992: {
            slidesPerView: 1,
          },
          0: {
            slidesPerView: 1,
          }
        },
      });

    });
    $(".quick-view-popup").addClass("active");
    $("body").addClass("no-scroll");
  });
  
$('body').on('click', '.quickview_popup_data .select-material-grp .button', function() {
   var data_val = $(this).children('input:checked').val();
   $(this).parents('.radio-buttons').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .select-material-grp .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
         $('.quickview_popup_data .product-form__submit > svg').remove();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
/******* quick-view-popup end *******/
  
// load-more button scroll
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val();
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val(datacollurl + "?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-grid-view, .product-list-view').append($(responseHTML).find('.product-grid-view, .product-list-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

      jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.prod-label').prependTo(prod_lable);

        var stock_label = jQuery(this).find('.prod-label');
        jQuery(this).find('.stock-label').insertAfter(stock_label);

        var prod_des = jQuery(this).find('h3');
        jQuery(this).find('.product-des').insertAfter(prod_des);

        var coll_count = jQuery(this).find('.product-des');
        jQuery(this).find('.collection-counter').insertAfter(coll_count);

        var prod_bottom = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_bottom);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);

        var prod_price = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_price);

        var prod_var = jQuery(this).find('.price');
        jQuery(this).find('.size-select').insertAfter(prod_var);

        var prod_btn = jQuery(this).find('.size-select');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_btn);
        
      });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    
   $(".menu-lnk.has-item").hover(function () {
    $('body').toggleClass("no-scroll");
 });
  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-list-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

// load-more button scroll end

   // custom review
  $(window).on("load", function() {
    $(".sticky-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#111111' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>")
  });
  
  setTimeout(function() {
    $('.sticky-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab').find(".has-children.is-open").removeClass('is-open');
    $('.pdp-tab').find(".has-children.review_tab").addClass('is-open');
    $('.pdp-tab .has-children .acnav-list').hide();
     $('.pdp-tab .review_tab .review_tab_content').show();
    });
  }, 1000); 

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });


 // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products_add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products_add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.product-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky

  
  
    // product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
});
// infinit scroll
function initializeAjaxinate(containerSelector) {
  var endlessScroll = new Ajaxinate({
    container: containerSelector,
    pagination: '#collection-Pagination',
    loadingText: '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
    callback: callbackInfiniteScroll
  });
}
function callbackInfiniteScroll() {
  countDownIni('.flip-countdown,.js-flip-countdown');

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.pro-labl').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content .product-description ');
        jQuery(this).find('.product-offer-timeline').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.rating-wrp').prependTo(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.product-card-social-icon').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-card-social-icon');
        jQuery(this).find('.size-select').insertAfter(prod_img);
      });
}
document.addEventListener("DOMContentLoaded", function() {
  initializeAjaxinate('.product-grid-view');

  const list_view = document.querySelector(".list-view");
  if(list_view){
      list_view.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-list-view')) {
      initializeAjaxinate('.product-list-view');
    }
  });
  }
  
});
//end infinite

function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
  }

  if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('ul');
      newDiv.className = 'mobile-lag d-flex align-items-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.country-name, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.country-name, .languages').appendTo('ul.announcebar-right');
    $('.mobile-lag').remove();
  }
  
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<div class="counter"><h6>%D</h6><span>days</span></div>' + '<div class="counter"><h6>%H</h6><span>hrs</span></div>' + '<div class="counter"><h6>%M</h6><span>min</span></div>' + '<div class="counter"><h6>%S</h6><span>sec</span></div>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}
